(ns minorodata.components.dynamic-docs.core
  (:require ["allotment" :refer [Allotment]]
            [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.dynamic-docs.panel :refer [panel]]
            [minorodata.components.dynamic-docs.sidebar :refer [sidebar]]
            [reagent.core :as reagent]
            [ui.page :refer [page-content page-header page-root
                             page-title]]))


(defn dynamic-docs-page []
  [page-root {:class "grid grid-rows-[auto_1fr] print:block min-h-0 h-screen overflow-hidden print:overflow-visible"}
   [page-header {:class   "print:hidden"
                 :variant :border}
    [page-title "Data docs"]]

   [page-content {:variant :border
                  :class   "print:block print:overflow-visible"}
     [:> Allotment {:min-size      200
                           :default-sizes [20 80]}
      [:div {:class "border-r print:hidden items-start overflow-y-auto h-full"}
       [sidebar]]
      [:div {:class "h-full overflow-y-auto print:overflow-visible"}
       [panel]]]]])

(defn main []
  (reagent/create-class
   {:display-name
    "dynamic-docs-page"

    :constructor
    (fn []
      (dispatch [:transformations.api/fetch-tags])
      (dispatch [:users.api/fetch-searchable-users])
      (dispatch [:transformations-search/add {:transformations-search/type :both}])
      (dispatch [:groups-panel/add nil])
      (dispatch [:group.api/fetch-groups {:replace? true
                                          :items-per-page 1000}]))

    :component-will-unmount
    (fn []
      (dispatch-sync [:groups-panel/delete])
      (dispatch-sync [:transformations-search/delete]))

    :render
    (fn []
      [dynamic-docs-page])}))
